// extracted by mini-css-extract-plugin
export default {"tabButton":"style_tabButton__YEun7","tabs":"style_tabs__lJTlp","tabsHidden":"style_tabsHidden__kDJ+s","tabPanel":"style_tabPanel__P0s9a"};